import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import Container from 'blocks/Container/Container';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Bind } from 'lodash-decorators';
import { ImageSlider as ImageSliderModel } from 'models';
import { observable } from 'mobx';
import ds from 'designsystem';
import { safeHtmlWithBr } from 'common/methods/string';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import Button from 'blocks/SliderButtons/Button';
import ArrowLeft from 'blocks/SliderButtons/ArrowLeft';
import ArrowRight from 'blocks/SliderButtons/ArrowRight';
import ButtonWrapper from './ButtonWrapper';
import Header from './Header';
import Background from './Background';
import ImageSlide from './ImageSlide';

@observer
class ImageSlider extends Component {
  @observable currentImageIndex = 0;

  @observable hasBeenSeen = false;

  canChangeSlide = true;

  componentDidMount() {
    const {
      data: {
        imageSlides,
      },
    } = this.props;
    this.currentImageIndex = imageSlides.length - 1;
  }

  @Bind
  onSliderInViewport(isInViewport) {
    if (isInViewport && !this.hasBeenSeen) {
      setTimeout(() => {
      // this.nextImage(); // Todo: TEMPORARILY DISABLED FUNCTIONALITY
        this.hasBeenSeen = true;
      }, 300);
    }
  }

  @Bind
  setCanChangeSlide(canChangeSlide) {
    this.canChangeSlide = canChangeSlide;
  }

  @Bind
  nextImage() {
    if (!this.canChangeSlide) {
      return;
    }
    const { data: { imageSlides } } = this.props;
    if (imageSlides.length > (this.currentImageIndex + 1)) {
      this.currentImageIndex = this.currentImageIndex + 1;
    } else {
      this.currentImageIndex = 0;
    }
  }

  @Bind
  previousImage() {
    if (!this.canChangeSlide) {
      return;
    }
    const { data: { imageSlides } } = this.props;
    if ((this.currentImageIndex - 1) < 0) {
      this.currentImageIndex = imageSlides.length - 1;
    } else {
      this.currentImageIndex = this.currentImageIndex - 1;
    }
  }

  render() {
    const {
      data: {
        header,
        imageSlides,
        htmlModifiers,
      },
    } = this.props;

    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('white')}
      >
        <Background>
          <Container>
            <Header
              dangerouslySetInnerHTML={{
                __html: safeHtmlWithBr(header),
              }}
            />
          </Container>
        </Background>

        <ImageSlide
          currentImageIndex={this.currentImageIndex}
          data={imageSlides[this.currentImageIndex]}
          setCanChangeSlide={this.setCanChangeSlide}
        />

        {
          imageSlides.length > 1 && (
            <ButtonWrapper>
              <Button
                onClick={this.previousImage}
              >
                <VisibilitySensor
                  onChange={this.onSliderInViewport}
                >
                  <ArrowLeft animate />
                </VisibilitySensor>
              </Button>
              <Button
                onClick={this.nextImage}
              >
                <ArrowRight animate />
              </Button>
            </ButtonWrapper>

          )
        }
      </HTMLModifiableBackground>
    );
  }
}
ImageSlider.propTypes = {
  data: PropTypes.instanceOf(ImageSliderModel).isRequired,
};

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/index.jsx